import {
  AutoComplete,
  FormContainer,
  ISelectType,
  SwitchInput,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  createMarComAutomationClassification,
  getMarComAutomationClassificationById,
  updateMarComAutomationClassification,
} from "../../../../../../services/marComAutomationClassifications.service";
import { IMarComAutomationClassificationProps } from "./models";
import {
  classificationsSchema,
  TClassificationsForm,
} from "./classificationSchema";
import { listClassificationsByProfileAccess } from "../../../../../../services/listProfileAccess.service";

const translationPath = "page.4uMarCom.automationRules.marcom_classifications.";

export const Classifications = memo(
  ({
    id,
    marComAutomationRuleId,
    onBackButton,
  }: IMarComAutomationClassificationProps) => {
    const { t } = useTranslation();

    const { sendRequest: save, loading: sLoading } = useFetch(
      createMarComAutomationClassification
    );

    const { sendRequest: update, loading: uLoading } = useFetch(
      updateMarComAutomationClassification
    );

    const { sendRequest: get, loading: gLoading } = useFetch(
      getMarComAutomationClassificationById
    );

    const updateHandler = (v: TClassificationsForm, id: string) =>
      update({
        item: {
          id: id,
          marComAutomationRuleId: marComAutomationRuleId ?? "",
          listClassificationId: v.listClassification.id,
        },
        id: id,
      });

    const saveHandler = (v: TClassificationsForm) =>
      save({
        marComAutomationRuleId: marComAutomationRuleId ?? "",
        listClassificationId: v.listClassification.id,
      });

    const getHandler = useCallback(
      async (id: string): Promise<Treturn<TClassificationsForm>> => {
        const { data, success } = await get(id);

        if (data) {
          const newData: TClassificationsForm = {
            ...data,
            listClassification: data.listClassification,
          };
          return { data: newData, success: true };
        }
        return { data, success };
      },
      [get]
    );
    const successHandle = () => {
      onBackButton();
    };
    const loading = sLoading || uLoading || gLoading;
    return (
      <FormContainer<TClassificationsForm>
        saveFunction={saveHandler}
        updateFunction={updateHandler}
        getFunction={getHandler}
        loading={loading}
        title={t(translationPath + "title")}
        schema={classificationsSchema}
        subtitle={t(translationPath + "new")}
        backButtonOnClick={onBackButton}
        redirectOnSave={false}
        onSuccess={successHandle}
        isModalForm={true}
        propId={id}
        formActionsOnBottom={false}
        fields={() => (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <AutoComplete
                getOptionLabel={({ name }) => name}
                size="small"
                label={t(translationPath + "list_classification")}
                name="listClassification"
                request={listClassificationsByProfileAccess}
                clearIcon={false}
              />
            </Grid>
          </Grid>
        )}
      />
    );
  }
);
